import { Box } from "@mui/material";
import AddUserForm from "../../elements/AddUserForm";
import TableUsers from "../../elements/TableUsers";
import TableClientsDetail from "../../elements/TableClientsDetail";
import { AllUsersInterface } from "../../../interface/allUsersInterface";
import { useEffect, useState } from "react";
import axiosInstance from "../../../services/axios-instance";
import { All_USERS_URL } from "../../../services/endpoints";
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";
import { useNavigate } from 'react-router-dom';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }
  
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
const AdminTrackTime = () => {

    const navigate = useNavigate();
    const dialogPaperStyle = {
        minWidth: '600px',
      };
    
    const [users, setUsers] = useState<AllUsersInterface[]>([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [refetchUsers, setRefetchUsers] = useState(false);
    const [value, setValue] = useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
        console.log(event);
    };
    const handleAddUser = (newUser: Partial<AllUsersInterface>) => {
        setUsers([...users, newUser as AllUsersInterface]);
        setOpenDialog(false);
    };

    const handleCancelClick = () => {
        setOpenDialog(false);
    };

    const handleOpenClick = () => {
        setOpenDialog(true);
    };

    const handleRedirect = () => {
        navigate('/users/report');
      };

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await axiosInstance.get(All_USERS_URL);
                setUsers(response.data.data);
                setRefetchUsers(false);
            } catch (error) {
                console.error(error);
            }
        };

        fetchUsers();
    }, [refetchUsers]);

    return (
        <>
            <Button variant="contained" color="info" onClick={handleOpenClick}>
                Add user
             </Button>
             <Button 
                  sx={{
                    marginLeft: "1rem",
                }}
                variant="contained" 
                color="info" 
                onClick={handleRedirect}>
                Table View Report
             </Button>
             <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label="Empoyees" {...a11yProps(0)} />
                    <Tab label="Clients" {...a11yProps(1)} />
                    </Tabs>
                </Box>
                <CustomTabPanel value={value} index={0}>
                    <Box>
                        <TableUsers
                            users={users.filter(user => user.role_id !== 3)}
                            setUsers={setUsers}
                            setRefetchUsers={setRefetchUsers}
                        />                    
                    </Box>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                <Box>
                        <TableClientsDetail
                            users={users.filter(user => user.role_id == 3)}
                            setUsers={setUsers}
                            setRefetchUsers={setRefetchUsers}
                        />                    
                    </Box>
                </CustomTabPanel>
            </Box>
            <Dialog PaperProps={{ style: dialogPaperStyle }} open={openDialog}>
                    <DialogTitle>Add User</DialogTitle>
                    <DialogContent>
                        <AddUserForm onAddUser={handleAddUser} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCancelClick} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>
             </Dialog>
        </>
    );
};

export default AdminTrackTime;
